<template>
	<div class="product-wrap fx">
		<div class="prodtct-container">
			<div class="header">
				<h1 class="animate">
					<span class="title">{{ $t('pageTitle1') }}</span>
					<span class="clr-1f title">{{ $t('pageTitle2') }}</span>
				</h1>
			</div>
			<div class="product-inner">
				<div class="product-inner-container">
					<LazyImage :imagePath="imagePath"></LazyImage>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'iptvProduct',
		components: {},
		data() {
			return {
				windowWidth: window.innerWidth,
				imagePath: require('@/static/img/product-screen-img1.png')
			}
		},
		mounted() {
			this.updateImagePath();
			window.addEventListener('resize', this.handleResize);
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.handleResize);
		},
		methods: {
			handleResize() {
				this.windowWidth = window.innerWidth;
				this.updateImagePath();
			},
			updateImagePath() {
				this.imagePath = this.windowWidth > 768 ?
					require('@/static/img/product-screen-img1.png') :
					require('@/static/img/product-screen-img.png');
			}
		},
		updated() {},
	}
</script>
<style lang='less' scoped>
	.fx {}

	.product-wrap {
		box-sizing: content-box;
		position: relative;
	}

	.prodtct-container {
		margin: 0 auto;
		height: 100%;
		max-width: 1280px;
		margin: 0 auto;
		background: radial-gradient(50% 78% at 50% 100%, #FFFFFF 0%, rgba(232, 246, 255, 0) 100%);
	}


	.bg-gradient {
		position: absolute;
		bottom: 0;
		height: 800px;
		width: 100%;
		top: 0;
	}

	.header {
		width: 100%;
		padding: 0 24px;

		.clr-1f {
			color: #1ef8a0;
		}

		.title {
			font-size: 72px;
		}
	}

	h1 {
		word-break: break-all;
		padding-top: 75px;
		text-align: center;
		font-weight: normal !important;
		font-family: 'Alibaba PuHuiTi H';
	}

	.product-inner {
		display: flex;
		align-items: flex-end;
		padding-top: 55px;

		.product-inner-container {
			height: 100%;
		}

		img {
			width: 100%;
			height: 100%;
			display: block;
		}
	}

	@media (max-width: 768px) {
		.product-inner {
			min-height: 150px;
		}

		.prodtct-container {
			background: radial-gradient(100% 67% at 50% 100%, #FFFFFF 0%, rgba(232, 246, 255, 0) 100%) !important;
		}

		h1 {
			padding-top: 32px !important;
		}

		.title {
			font-size: 48px !important;
		}
	}
</style>
